<i18n
  src="@/locales/views/service_provider/services/container_op/edit_service.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container_service.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="sp_services_container_op_show_schedule_path"
    :params="{
      service_provider_id: service_provider_id,
      container_scheduled_service_id: container_scheduled_service_id,
    }"
  />
  <bread-crumbs
    :labels="[module_name, container_service?.service_template?.name]"
  ></bread-crumbs>
  <template v-if="container_service">
    <container-scheduled-service-info
      :container_scheduled_service="container_scheduled_service"
    />
    <alert-danger :errors_data="std_err" />
    <div class="mt-8" v-if="container_service">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
            {{ container_service?.service_template?.name }}
          </h3>
        </div>
        <div class="panel-body" v-if="container_service">
          <div class="space-y-8 divide-y divide-gray-200">
            <div
              class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
              v-if="container_schedule_technicians.length > 0"
            >
              <div class="sm:col-span-6">
                <label class="label-form">
                  {{
                    $t(
                      "model.container_service.container_schedule_technician_id"
                    )
                  }}
                </label>
                <div class="mt-1">
                  <select-form
                    v-if="container_schedule_technicians.length > 0"
                    class="custom-tailwind-select w-full"
                    :options="container_schedule_technicians"
                    v-model="container_service.container_schedule_technician_id"
                    label="name"
                  />
                </div>
              </div>
            </div>
            <div class="pt-2">
              <div
                class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 content-end"
              >
                <div class="sm:col-span-3 self-end">
                  <label class="label-form">
                    {{ $t("model.container_service.started_at") }}
                  </label>
                  <div class="mt-1">
                    <date-form
                      v-model="container_service.started_at"
                      mode="dateTime"
                      :first-day-of-week="2"
                      locale="es"
                      show-iso-weeknumbers
                    ></date-form>
                  </div>
                </div>
                <div class="sm:col-span-3">
                  <label class="label-form">
                    <switch-form
                      v-model="container_service.finished"
                      @change="changeFinisehd($event)"
                      :label="$t('model.container_service.finished')"
                    />
                  </label>
                  <div class="mt-1">
                    <date-form
                      v-if="render_finished_at"
                      v-model="container_service.finished_at"
                      mode="dateTime"
                      :first-day-of-week="2"
                      locale="es"
                      show-iso-weeknumbers
                    ></date-form>
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-2" v-if="service_template_tasks.length > 0">
              <ul class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
                <li
                  class="sm:col-span-3"
                  v-for="service_template_task in service_template_tasks"
                  :key="service_template_task.id"
                >
                  <switch-form
                    v-model="container_service_tasks[service_template_task.id]"
                    :label="service_template_task.name"
                  />
                </li>
              </ul>
            </div>
            <div
              class="pt-2"
              v-if="not_detailed_service_template_measures.length > 0"
            >
              <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
                <div
                  class="sm:col-span-3"
                  v-for="service_template_measure in not_detailed_service_template_measures"
                  :key="service_template_measure.id"
                >
                  <label class="label-form">
                    {{ service_template_measure.name }}
                    <template v-if="service_template_measure.unit">
                      <em> ({{ service_template_measure.unit.name }}) </em>
                    </template>
                  </label>
                  <input
                    type="text"
                    v-model.number="
                      container_service_measures[service_template_measure.id]
                    "
                    class="input-text"
                  />
                </div>
              </div>
            </div>
            <div
              class="pt-2"
              v-if="detailed_service_template_measures.length > 0"
            >
              <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
                <div
                  class="sm:col-span-12"
                  v-for="service_template_measure in detailed_service_template_measures"
                  :key="service_template_measure.id"
                >
                  <label class="label-form">
                    {{ service_template_measure.name }}
                    <template v-if="service_template_measure.unit">
                      <em> ({{ service_template_measure.unit.name }}) </em>
                    </template>
                  </label>
                  <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
                    <div
                      class="sm:col-span-1"
                      v-for="detail in service_template_measure.num_details"
                      :key="detail"
                    >
                      <input
                        v-if="
                          container_service_measures[
                            service_template_measure.id
                          ]
                        "
                        type="text"
                        v-model.number="
                          container_service_measures[
                            service_template_measure.id
                          ][detail]
                        "
                        class="input-text"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-2" v-if="service_template_inputs.length > 0">
              <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
                <div
                  class="sm:col-span-3"
                  v-for="service_template_input in service_template_inputs"
                  :key="service_template_input.id"
                >
                  <label class="label-form">
                    {{ service_template_input.name }}
                  </label>
                  <input
                    type="text"
                    v-model="
                      container_service_inputs[service_template_input.id]
                    "
                    class="input-text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer" v-if="container_service">
          <div class="panel-footer-actions">
            <div class="panel-footer-actions">
              <white-button
                @click.prevent="goToShowSchedule()"
                :label="$t('labels.cancel_button')"
              />
              <span class="space-actions"></span>
              <success-button
                v-if="!charging_submit"
                @click.prevent="submit()"
                :label="$t('labels.save_button')"
              />
              <success-button-processing
                v-else
                :label="$t('labels.save_button')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
  <div />
</template>

<script>
import Requester from "@/views/service_provider/requesters/services/container_op/edit_service.js";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
import ContainerScheduledServiceInfo from "@/components/views/service_provider/services/container_op/ContainerScheduledServiceInfo.vue";

import moment from "moment";
import { nextTick } from "vue";

export default {
  components: {
    BreadCrumbs,
    ContainerScheduledServiceInfo,
  },
  props: [
    "service_provider_id",
    "container_scheduled_service_id",
    "container_service_id",
  ],
  data() {
    return {
      container_service: null,
      container_schedule_technicians: [],
      original_container_service_inputs: [],
      original_container_service_tasks: [],
      original_container_service_measures: [],
      active_service_templates: {},
      charging_submit: false,
      container_service_tasks: {},
      container_service_measures: {},
      container_service_inputs: {},
      render_finished_at: true,
    };
  },
  computed: {
    can_send: function () {
      return !this.charging_submit;
    },
    container_service_inputs_params: function () {
      return this.service_template_inputs
        .map((service_template_input) => {
          let original = this.original_container_service_inputs.find(
            (original) =>
              original.service_template_input_id == service_template_input.id
          );
          return {
            id: original?.id ?? null,
            service_template_input_id: service_template_input.id,
            value: this.container_service_inputs[service_template_input.id],
            _destroy:
              Boolean(original) &&
              !this.container_service_inputs[service_template_input.id],
          };
        })
        .filter(
          (service) =>
            service._destroy ||
            this.container_service_inputs[service.service_template_input_id]
        );
    },
    container_service_measures_params: function () {
      return this.not_detailed_service_template_measures
        .map((service_template_measure) => {
          let original = this.original_container_service_measures.find(
            (original) =>
              original.service_template_measure_id ==
              service_template_measure.id
          );
          return {
            id: original?.id ?? null,
            service_template_measure_id: service_template_measure.id,
            value:
              Number(
                this.container_service_measures[service_template_measure.id]
              ) ?? 0,
            _destroy:
              Boolean(original) &&
              Number(
                this.container_service_measures[service_template_measure.id]
              ) == 0,
          };
        })
        .filter(
          (service) =>
            service._destroy ||
            this.container_service_measures[service.service_template_measure_id]
        );
    },
    container_service_measures_params_with_details: function () {
      return this.detailed_service_template_measures
        .map((service_template_measure) => {
          let original = this.original_container_service_measures?.find(
            (original) =>
              original.service_template_measure_id ==
              service_template_measure.id
          );
          let details = this.getMeasureDetails(
            service_template_measure,
            original
          );
          return {
            id: original?.id ?? null,
            service_template_measure_id: service_template_measure.id,
            service_measure_details: details ?? [],
            _destroy: Boolean(original) && details.length == 0,
          };
        })
        .filter(
          (service) =>
            service._destroy || service.service_measure_details.length > 0
        );
    },
    container_service_tasks_params: function () {
      return this.service_template_tasks
        .map((service_template_task) => {
          let original = this.original_container_service_tasks.find(
            (original) =>
              original.service_template_task_id == service_template_task.id
          );
          return {
            id: original?.id ?? null,
            service_template_task_id: service_template_task.id,
            _destroy:
              Boolean(original) &&
              !this.container_service_tasks[service_template_task.id],
          };
        })
        .filter(
          (service_template) =>
            service_template._destroy ||
            this.container_service_tasks[
              service_template.service_template_task_id
            ]
        );
    },
    finished_at_formated: function () {
      let finished_at = this.container_service?.finished_at;
      if (finished_at) return moment(finished_at).format("YYYY-MM-DD hh:mm a");
      return "";
    },
    service_template_inputs: function () {
      return this.container_service.service_template.service_template_inputs;
    },
    service_template_files: function () {
      return this.container_service.service_template.service_template_files;
    },
    container_service_values_params: function () {
      return {
        container_service_inputs: this.container_service_inputs_params,
        container_service_measures: this.container_service_measures_params,
        container_service_measures_with_details:
          this.container_service_measures_params_with_details,
        container_service_tasks: this.container_service_tasks_params,
      };
    },
    service_template_measures: function () {
      return (
        this.container_service?.service_template?.service_template_measures ??
        []
      );
    },
    not_detailed_service_template_measures: function () {
      return this.service_template_measures.filter(
        (service_template_m) => service_template_m.use_details == false
      );
    },
    detailed_service_template_measures: function () {
      return this.service_template_measures.filter(
        (service_template_m) => service_template_m.use_details
      );
    },
    service_template_tasks: function () {
      return this.container_service.service_template.service_template_tasks;
    },
    params: function () {
      return {
        container_service_id: this.container_service_id,
        container_schedule_technician_id:
          this.container_service?.container_schedule_technician_id,
        started_at: this.started_at_formated,
        finished_at: this.finished_at_formated,
        finished: this.container_service.finished,
        container_service_values: this.container_service_values_params,
      };
    },
    save_link_class: function () {
      let basic_class = "btn-main";
      if (this.can_send) return basic_class;
      return `${basic_class}  opacity-50 cursor-not-allowed`;
    },
    started_at_formated: function () {
      let started_at = this.container_service?.started_at;
      if (started_at) return moment(started_at).format("YYYY-MM-DD hh:mm a");
      return "";
    },
  },
  methods: {
    changeFinisehd: async function (finished) {
      if (finished && !this.container_service.finished_at) {
        this.render_finished_at = false;
        this.container_service.finished_at = this.container_service.started_at;
        await nextTick();
        this.render_finished_at = true;
      }
    },
    fetchTechnicians: async function () {
      let response = await Requester.fetchTechnicians({
        container_service_id: this.container_service_id,
      });
      let container_schedule_technicians = response.data;
      container_schedule_technicians = container_schedule_technicians.map(
        (container_schedule_technician) => {
          container_schedule_technician.name =
            container_schedule_technician.user.name;
          return container_schedule_technician;
        }
      );
      this.container_schedule_technicians = container_schedule_technicians;
    },
    fetchSchedule: async function () {
      let response = await Requester.fetchSchedule({
        container_service_id: this.container_service_id,
      });
      this.container_scheduled_service = response.data;
    },
    fetchService: async function () {
      let response = await Requester.fetchService({
        container_service_id: this.container_service_id,
      });
      let container_service = response.data;
      this.formatInitDates(container_service);
      this.fillInputs(container_service);
      this.fillMeasures(container_service);
      this.fillTasks(container_service);
      this.container_service = container_service;
    },
    fillInputs: function (container_service) {
      this.original_container_service_inputs =
        container_service.container_service_inputs ?? [];
      container_service.container_service_inputs.forEach(
        (container_service_input) => {
          this.container_service_inputs[
            container_service_input.service_template_input_id
          ] = container_service_input.value;
        }
      );
    },
    fillMeasures: function (container_service) {
      this.original_container_service_measures =
        container_service.container_service_measures ?? [];
      const service_template_measures =
        container_service?.service_template?.service_template_measures;
      const detailed_service_template_measures =
        service_template_measures.filter(
          (service_template_m) => service_template_m.use_details
        );
      detailed_service_template_measures.forEach((service_template_m) => {
        this.container_service_measures[service_template_m.id] = {};
      });
      container_service.container_service_measures.forEach(
        (container_service_measure) => {
          const service_template = service_template_measures.find(
            (service_template_m) =>
              service_template_m.id ==
              container_service_measure.service_template_measure_id
          );
          if (!service_template) return;

          if (service_template.use_details) {
            let details = container_service_measure.service_measure_details;
            for (let d = 0; d < details.length; d++) {
              const detail = details[d];
              this.container_service_measures[
                container_service_measure.service_template_measure_id
              ][detail.detail_pos] = detail.value;
            }
          } else {
            this.container_service_measures[
              container_service_measure.service_template_measure_id
            ] = container_service_measure.value;
          }
        }
      );
    },
    fillTasks: function (container_service) {
      this.original_container_service_tasks =
        container_service.container_service_tasks ?? [];
      container_service.container_service_tasks.forEach(
        (container_service_task) => {
          this.container_service_tasks[
            container_service_task.service_template_task_id
          ] = container_service_task.completed;
        }
      );
    },
    formatInitDates: function (container_service) {
      container_service.started_at = this.removeTimeZoneToDate(
        container_service.started_at
      );
      container_service.finished_at = this.removeTimeZoneToDate(
        container_service.finished_at
      );
    },
    getMeasureDetails: function (
      service_template_measure,
      original_container_service_measure = {}
    ) {
      let input_details =
        this.container_service_measures[service_template_measure.id];
      let details = [];
      for (const detail_pos in input_details) {
        if (Object.hasOwnProperty.call(input_details, detail_pos)) {
          const value = input_details[detail_pos];
          let original =
            original_container_service_measure.service_measure_details?.find(
              (smd) => smd.detail_pos == detail_pos
            );
          details.push({
            value: value,
            detail_pos: Number(detail_pos),
            id: original?.id ?? null,
            _destroy: original?.id && !value,
          });
        }
      }
      return details;
    },
    goToShowSchedule: function () {
      this.$router.push({
        name: "sp_services_container_op_show_schedule_path",
        params: {
          container_service_id: this.container_service_id,
          service_provider_id: this.service_provider_id,
        },
      });
    },
    submit: async function () {
      if (!this.can_send) return;
      this.charging_submit = true;
      try {
        let response = await Requester.update(this.params);
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToShowSchedule();
      } catch (error) {
        if (error?.response?.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
      this.charging_submit = false;
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => {
        this.fetchTechnicians();
        this.fetchSchedule().then(() => {
          this.fetchService();
        });
      })
    );
  },
};
</script>
